import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalTitle, ModalFooter, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Personal from "./personal";
import Professional from "./professional";

interface AddUserModalProps {
    show: boolean;
    onHide: () => void;
    isEdit: boolean;
    userData?: any;
    moduleLst: (data: any[]) => void;
    roleDet: (data: any[]) => void;
    onSave: (data: any) => void;
}

const AddUser: React.FC<AddUserModalProps> = ({ show, onHide, isEdit, userData, moduleLst, roleDet, onSave }) => {

    const [activeTab, setActiveTab] = useState("Personal");
    const [personalData, setPersonalData] = useState({});
    const [professionalData, setProfessionalData] = useState({});

    const handlePersonalDataChange = (data: any) => setPersonalData(data);
    const handleProfessionalDataChange = (data: any) => setProfessionalData(data);

    const handleSubmit = () => {
        const finalData = { ...personalData, ...professionalData };
        // console.log("Submitting Data:", finalData);
        onSave(finalData);
    };

    const handleNext = () => {
        setActiveTab("Professional");
    };

    const handleBack = () => {
        setActiveTab("Personal");
    };

    const tabData = [
        {
            icon: <i className="fas fa-child" />,
            name: "Personal",
            content: <Personal onDataChange={handlePersonalDataChange} userDet={userData} onNext={handleNext} />
        },
        {
            icon: <i className="fas fa-university" />,
            name: "Professional",
            content: <Professional onDataChange={handleProfessionalDataChange} userDet={userData} onBack={handleBack} isEdit={isEdit} moduleDet={moduleLst} roleDet={roleDet} submit={handleSubmit} />
        },
    ]

    return (
        <>
            <Modal show={show} onHide={onHide} size="xl" centered>
                <ModalHeader>
                    <ModalTitle>
                        <i className="fas fa-plus" />
                        Register New User
                    </ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="row d-flex align-items-center">
                            <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                <div className="coach-court-list">
                                    <ul className="nav">
                                        {tabData.map((tab, i) => (
                                            <li key={i} style={{ flex: "1", textAlign: "center", width: "100%" }}>
                                                <Link to="#"
                                                    className={tab.name === activeTab ? 'active' : ''}
                                                    style={{ display: "block", width: "100%" }}
                                                    onClick={() => setActiveTab(tab.name)}>
                                                    {tab.icon}  {tab.name}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="tab-content">
                                {tabData
                                    .filter(tab => tab.name === activeTab)
                                    .map((tab, i) => (
                                        <div key={i}>{tab.content}</div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};

export default AddUser;